import React, { useState, useEffect, useContext } from 'react'
import Utilities from '../../../../../../services/commonservice/utilities';
import HPTSelect from '../../../../../templates/components/HPTSelect';
const TreatmentPlanDetailForm = (props) => {
    // Pull properties form parent
    const { isEdit, submitHandler } = props;
    const [formData, setFormData] = useState(props?.initialData || {})
    const [doctorList, setDoctorList] = useState()
    const [serviceList, setServiceList] = useState([])
    const [productList, setProductList] = useState()

    const [selectedProvider, setSelectedProvider] = useState()
    
    useEffect(() => {
        setDoctorList(props?.doctorList)
        setProductList(props?.productList)
    }, [])

    useEffect(() => {
        //service reset
        inputChange({
            target:
                { value: null, name: "practiceServiceTypeId" }
        })
        if (selectedProvider) {
            setServiceList(selectedProvider.services)
        } else {
            setServiceList([])
        }
    }, [selectedProvider])

    // formula for input change
    const inputChange = (e) => {
        let newStateObject = { ...formData };
        newStateObject[e.target.name] = e.target.value
        return setFormData(newStateObject);
    };

    useEffect(() => {
        //edit
        if (isEdit && props?.initialData?.doctorId) {
            setSelectedProvider(doctorList?.find(obj => obj.id === formData.doctorId))
        }
    }, [doctorList])



    return (
        <>
            <div className=" fields p-3">
                <div className="row">
                    <div className="field col-12 required">
                        <label>Provider</label>
                        <HPTSelect
                            options={doctorList}
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={e => {
                                setSelectedProvider(e)
                                if (e?.id) {
                                    inputChange({
                                        target:
                                            { value: e.id, name: "doctorId" }
                                    })
                                }
                                else {
                                    inputChange({
                                        target:
                                            { value: null, name: 'doctorId' }
                                    })
                                }
                            }}
                            value={formData.doctorId && doctorList?.find(obj => obj.id === formData.doctorId)}
                            isClearable={true}
                            isLoading={!doctorList}
                            isDisabled={!doctorList}
                            loadingMessage="Retrieving list of providers"
                            placeholder="All Providers"
                            getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                            getOptionValue={(option) => option.id}
                        />
                    </div>
                    <div className="field col-12">
                        <label>Date Planned</label>
                        <input
                            onChange={(e) => {
                                e.preventDefault();
                                inputChange(e)
                            }}
                            type="date"
                            min="1900-01-01"
                            //max={moment().format("YYYY-MM-DD")}
                            name="datePlanned"
                            value={formData.datePlanned ? Utilities.toDate(formData.datePlanned): null}
                        />
                    </div>
                    <div className="field col-12">
                        <label>Service</label>
                        <HPTSelect
                            options={serviceList}
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={e => {
                                if (e?.practiceServiceTypeId) {
                                    inputChange({
                                        target:
                                            { value: e.practiceServiceTypeId, name: "practiceServiceTypeId" }
                                    })
                                }
                                else {
                                    inputChange({
                                        target:
                                            { value: null, name: 'practiceServiceTypeId' }
                                    })
                                }
                            }}
                            value={formData.practiceServiceTypeId && serviceList && serviceList.find(obj => obj.practiceServiceTypeId === formData.practiceServiceTypeId)}
                            isClearable={true}
                            isLoading={!serviceList}
                            isDisabled={!serviceList}
                            loadingMessage="Retrieving list of services"
                            placeholder="All Services"
                            getOptionLabel={(option) => option.practiceServiceType}
                            getOptionValue={(option) => option.practiceServiceTypeId}
                        />
                    </div>
                    <div className="field col-12">
                        <label>Product</label>
                        <HPTSelect
                            options={productList}
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={e => {
                                if (e?.id) {
                                    inputChange({
                                        target:
                                            { value: e.id, name: "itemId" }
                                    })
                                }
                                else {
                                    inputChange({
                                        target:
                                            { value: null, name: 'itemId' }
                                    })
                                }
                            }}
                            value={formData.itemId && productList && productList.find(obj => obj.id === formData.itemId)}
                            isClearable={true}
                            isLoading={!productList}
                            isDisabled={!productList}
                            loadingMessage="Retrieving list of products"
                            placeholder="All Products"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                        />
                    </div>
                    <div className="field col-12">
                        <label>Quantity</label>
                        <input value={formData?.quantity} type="number" name="quantity" onChange={e => { e.preventDefault(); inputChange(e) }} />
                    </div>
                </div>
                <div className="mt-3 d-flex justify-content-between modal-button-bar">
                        <div className='col-auto'>
                            <button className="btn btn-primary" onClick={e => {
                                e.preventDefault();
                                submitHandler(formData)
                            }}
                            disabled={!(formData.doctorId ||
                                formData.datePlanned ||
                                formData.practiceServiceTypeId ||
                                formData.itemId ||
                                formData.quantity)}
                            >{isEdit ? 'Update' : 'Add'}</button>
                        </div >
                        <div className='col-auto'>
                            {props.onClose && <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); props.onClose() }}>Close</button>}
                        </div>
                    </div >
            </div >
        </>
    )
}

export default TreatmentPlanDetailForm